<template>
	<div class="wrapper-white-with-bgpic StationsHero">
		<div class="wrapper-img">
			<img class="img-fluid" :src="page.stationsImage">
		</div>
		<div class="container">
			<div class="row">
				<div class="col-lg-7 white-bg-rounded">
					<h4>{{page.stationText}}</h4>
					<div class="row">
						<div class="col-sm-6 col-lg-6">
							<!-- @todo stations left right machen -->
							<ul>
								<li v-for="city, name in cities">{{ name }}</li>
							</ul>
						</div>
					</div>
					<div class="wrapper-btn-center">
					<router-link :to="{name: 'PageRegister'}">
						<button type="button" class="btn btn-secondary btn-wp">{{page.buttonText3}}</button>
					</router-link>
				</div>
				</div>
			</div>

		</div>
	</div>
</template>


<script>
import { mapGetters } from 'vuex'

export default {
	name: "StationsHero",

	data() {
		return {
			cities: [],
			cities_length: 0,
			page: {}
		}
	},

	mounted() {
		const self = this;
		this.$store.dispatch('orm/GET_STATIONS_BY_CITY')
		.then(cities => {
			self.cities = cities;
			self.cities_length = cities.length;
		}).catch(err => { this.$store.commit("core/ADD_ERROR", err); })
		 this.$store.dispatch('orm/GET_HOMEPAGE')
		 .then(result => {
		 	self.page = result
		 }).catch(err => { this.$store.commit("core/ADD_ERROR", err); })
	}
}




</script>



// WEBPACK FOOTER //
// src/components/Modules/StationsHero.vue